/* Copyright 2013 - 2024 Waiterio LLC */
import Menu from '@waiterio/model/Menu.js'
import get from '@waiterio/api-client/get.js'

export default function getMenus(restaurantId) {
  return get({ url: `menus?restaurantId=${restaurantId}` }).then(menus =>
    menus.map(menu => new Menu(menu)),
  )
}
